/**
 * Generate a pagination array for a given current page and total number of pages.
 *
 * @param {number} currentPage - The current page.
 * @param {number} totalPages - The total number of pages.
 * @returns {Array} - An array representing the pagination with ellipses when necessary.
 */
export function pagination(currentPage, totalPages) {
    // Define constants and variables
    const delta = 1; // Number of pages to show before and after the current page
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    const range = [];
    const rangeWithDots = [];
    let previousPage;

    // Loop through all pages from 1 to the last page
    for (let page = 1; page <= totalPages; page++) {
        // Include the first page, last page, and pages within the delta range
        if (page === 1 || page === totalPages || (page >= left && page < right)) {
            range.push(page);
        }
    }

    // Build the pagination array with ellipses
    for (let currentPage of range) {
        if (previousPage) {
            // If there is a gap of 2 between pages, add the missing page
            if (currentPage - previousPage === 2) {
                rangeWithDots.push(previousPage + 1);
            }
            // If there is a gap of more than 2, add an ellipsis
            else if (currentPage - previousPage !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(currentPage);
        previousPage = currentPage;
    }

    return rangeWithDots;
}
